document.addEventListener('DOMContentLoaded', function () {

	//Select field dropdown arrow on fluent forms
	const selectElements = document.querySelectorAll("select");
	if(selectElements) {
		selectElements.forEach((selectElement) => {
			if (selectElement.parentElement.classList.contains("ff-el-input--content")) {
				selectElement.parentElement.classList.add("relative");
				selectElement.parentElement.innerHTML += "<i class='icon-Angle-Down absolute'></i>";
			}
		});
	}
});
